module.exports = __webpack_public_path__ + "static/media/follower_1.3e3974c3.png";